<!-- Localized -->
<template>
  <Checkbox
    :value="isAck"
    :disabled="disabled"
    @change="toggle"
  />
</template>

<script>
import Checkbox from "@shared/components/checkbox"

export default {
  name: 'checkbox',

  components: {
    Checkbox
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isAck: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      calculatedValue: false,
      key: 0,
    }
  },

  methods: {
    toggle() {
      this.$emit('input', !this.isAck);
    },
  }
}
</script>

<style lang="scss" scoped>
.icon {
  &:not(.active) {
    fill: #AFAFAF;
  }
}
.disabled {
  fill: #AFAFAF;
  cursor: not-allowed;
}
</style>